import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';

export function Orders() {
  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Directorio de Pedidos'}
        sx={{ px: { xs: '16px', md: '0px' }, pb: { xs: '0px', md: '16px' } }}
      />
      <NavigationTabs
        links={[
          {
            to: '/admin/orders/detail',
            label: 'Detalle de Pedido',
          },
          { to: '/admin/orders/pending', label: 'Pedidos por revisar' },
          { to: '/admin/orders/global', label: 'Pedidos Globales' },
        ]}
      />
    </TopLevelSectionLayout>
  );
}
